import { DetailPage, ListPage } from "./Pages";

export function PickupRequestPage() {
  return <></>;
}

PickupRequestPage.List = ListPage;
PickupRequestPage.Detail = DetailPage;
